module.exports = __webpack_public_path__ + "static/media/subGoogle1.5fd4910b.png";